/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC721A, ERC721AInterface } from "../ERC721A";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error",
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ConsecutiveTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC721AConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721AConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721A__factory extends ContractFactory {
  constructor(...args: ERC721AConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC721A";
  }

  deploy(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721A> {
    return super.deploy(name_, symbol_, overrides || {}) as Promise<ERC721A>;
  }
  getDeployTransaction(
    name_: string,
    symbol_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(name_, symbol_, overrides || {});
  }
  attach(address: string): ERC721A {
    return super.attach(address) as ERC721A;
  }
  connect(signer: Signer): ERC721A__factory {
    return super.connect(signer) as ERC721A__factory;
  }
  static readonly contractName: "ERC721A";
  public readonly contractName: "ERC721A";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721AInterface {
    return new utils.Interface(_abi) as ERC721AInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721A {
    return new Contract(address, _abi, signerOrProvider) as ERC721A;
  }
}
